export default {
  CONTACT_US: 'Contact Us',
  CONTACT_US_SUBTITLE:
    'Ralali is ready to assist you in growing your business and addressing various business challenges you may encounter.<br /> Our Business Consultants team will contact you shortly.',
  COMPANY_INFORMATION: 'Company Information',
  FIND_US: 'Find Us on Google Maps',
  POPULAR_PRODUCTS: 'Popular Products',
  RECOMMENDATED_PRODUCTS: 'Recommended Products',
  RECOMMENDATED_SUPPLIERS: 'Recommended Suppliers',
}
